import React from 'react';
import {Typography} from 'antd';

// Normalize real line endings for display only. Literal ^M, escaped sequences,
// Markdown, and HTML remain plain text; callers retain their original edit value.
export const normalizeTextAssetText = value => String(value ?? '').replace(/\r\n?/g, '\n');

export default function TextAssetText({children, lines, editable, style, ...props}) {
    return <Typography.Paragraph
        {...props}
        className="text-asset-text"
        data-preview-lines={lines}
        style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', marginBottom: 0, ...style}}
        ellipsis={lines ? {rows: lines, expandable: true} : false}
        editable={editable ? {...editable, text: editable.text ?? String(children ?? '')} : false}
    >{normalizeTextAssetText(children)}</Typography.Paragraph>;
}
